import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountLayout from "../../blocs/AccountLayout";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import Popup from "../../components/Popup";
import { fetchMyTransfers } from "../../store/slices/methodePaymentSlice";
import { StatusRdv } from "../../utils/utils";
import TooltipTwyny from "../../components/tooltip";
import { get } from "../../services/services";

const ListPayment = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [selectedTransferId, setSelectedTransferId] = useState(null);
  const statusIcons = StatusRdv();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { transfers, transfersStatus, transfersError } = useSelector(
    (state) => state.payment
  );

  useEffect(() => {
    dispatch(fetchMyTransfers())
      .unwrap()
      .then((response) => {
        // console.log('API Response:', response);
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  }, [dispatch]);

  const handleTransferClick = (transferId) => {
    navigate(`/compte/paiements/${transferId}`);
  };

  const handleDownloadInvoice = (id) => {
    window.open(
      process.env.REACT_APP_API_URL+'transfers/' +id+'/credit-note'+
        "?token=" +
        localStorage.getItem("token"),
      "_blank"
    );
    // console.log("Download invoice for transfer:", transferId);
    // get(`invoices/${id}`).then((res) => {
    //   // console.log(res?.data)
    //   window.open(
    //     res?.data?.stripe_receipt_url +
    //       "?token=" +
    //       localStorage.getItem("token"),
    //     "_blank"
    //   );
    // });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Date du rdv",
        accessor: "appointmentDate",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Date du paiement",
        accessor: "scheduled_date",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Client",
        accessor: "client",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Prestation",
        accessor: "prestation",
        Cell: ({ value }) => value || "N/A",
        className: "prestation-column", // Add this
        width: "25%",
        minWidth: "25%", // ensures it doesn't shrink below 25%
      },
      {
        Header: "Total TTC",
        accessor: "total",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Statut",
        accessor: "status",
        Cell: ({ value }) => <img src={statusIcons[value]} alt={value} />,
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const { id, appointment, status } = row.original;

          return (status === "completed" || status==="failed") ? (
            <div className="action-icons justify-content-center">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownloadInvoice(id);
                }}
                className="action-btn download"
              >
                <TooltipTwyny
                  children={<img src="/images/download.svg" alt="Download" />}
                  text="Télécharger la facture client"
                  className="left100"
                />
              </button>
              {/* <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownloadInvoice(id);
                }}
                className="action-btn view"
              >
                <TooltipTwyny
                  children={<img src="/images/file-down-02.svg" alt="View" />}
                  text="Télécharger ma facture twyny"
                  className="left100"
                />
              </button> */}
            </div>
          ) : null;
        },
      },
    ],
    [navigate]
  );

  const data = React.useMemo(() => {
    if (!transfers || !Array.isArray(transfers)) return [];

    return transfers.map((transfer) => ({
      id: transfer.id,
      appointment: transfer?.appointment_id,
      appointmentDate: transfer.appointment
        ? new Date(transfer.appointment?.start_time).toLocaleDateString("fr-FR")
        : "N/A",
      scheduled_date: transfer.scheduled_date
        ? new Date(transfer.scheduled_date).toLocaleDateString("fr-FR")
        : "N/A",
      client:
        `${transfer.appointment.user.prenom} ${transfer.appointment.user.nom}` ||
        "N/A",
      prestation: transfer.appointment.prestations_snapshot
        .map((p) => p.name)
        .join(", "),
      total: transfer.amount
        ? `${parseFloat(transfer.amount).toFixed(2)} €`
        : "0.00 €",
      status: transfer?.status || "N/A",
    }));
  }, [transfers]);

  if (transfersError) {
    return (
      <AccountLayout bgColor={"bgColor"}>
        <div className="error-message">
          Erreur lors du chargement des transferts: {transfersError.message}
        </div>
      </AccountLayout>
    );
  }

  return (
    <AccountLayout bgColor={"bgColor"}>
      <div className="section-title mb-16">
        <h3>Gestion des paiements</h3>
      </div>

      {transfersStatus === "loading" ? (
        <div className="">
          {/* Table Header */}
          <div className="row skeleton-header">
            <div className="col">
              {" "}
              <Skeleton height={24} />
            </div>
            <div className="col">
              {" "}
              <Skeleton height={24} />
            </div>
            <div className="col">
              {" "}
              <Skeleton height={24} />
            </div>
            <div className="col">
              {" "}
              <Skeleton height={24} />
            </div>
            <div className="col">
              {" "}
              <Skeleton height={24} />
            </div>
          </div>

          {/* Table Rows */}
          {[...Array(5)].map((_, index) => (
            <div key={index} className="row">
              <div className="col">
                <Skeleton height={20} />
              </div>
              <div className="col">
                {" "}
                <Skeleton height={20} />
              </div>
              <div className="col">
                {" "}
                <Skeleton height={20} />
              </div>
              <div className="col">
                <Skeleton height={20} />
              </div>
              <div className="col">
                <Skeleton height={20} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Table
          columns={columns}
          data={data}
          // onRowClick={(row) => handleTransferClick(row.id)}
        />
      )}

      {isPopupVisible && (
        <Popup
          isOpen={isPopupVisible}
          onClose={() => setPopupVisible(false)}
          title="Confirmation"
          text="Êtes-vous sûr de vouloir effectuer cette action ?"
          actionButtonText="Confirmer"
          onAction={() => {
            setPopupVisible(false);
          }}
        />
      )}
    </AccountLayout>
  );
};

export default ListPayment;
